import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { getWarehouseSortableId, WAREHOUSE_DND_TYPE } from '../../lib/dnd';
import cls from '../EquipmentBoard/EquipmentBoard.module.css';
import { WarehouseColumn } from '../WarehouseColumn/WarehouseColumn';

import type { Warehouse } from '@entities/equipment';

interface SortableWarehouseColumnProps {
    warehouse: Warehouse;
    warehouses: Warehouse[];
    inventoryItems: Warehouse['items'];
    hasFullAccess: boolean;
    currencySign: string;
    isFiltering: boolean;
    activeInventoryGuid: string | null;
    inventoryDropPreviewIndex: number | null;
    isInventoryDragDisabled: boolean;
}

export const SortableWarehouseColumn = ({
    warehouse,
    warehouses,
    inventoryItems,
    hasFullAccess,
    currencySign,
    isFiltering,
    activeInventoryGuid,
    inventoryDropPreviewIndex,
    isInventoryDragDisabled,
}: SortableWarehouseColumnProps) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: getWarehouseSortableId(warehouse.id),
        data: {
            type: WAREHOUSE_DND_TYPE,
            warehouseId: warehouse.id,
        },
        disabled: !hasFullAccess,
    });

    return (
        <div
            ref={setNodeRef}
            className={cls.sortableWarehouse}
            style={{
                transform: CSS.Transform.toString(transform),
                transition,
                opacity: isDragging ? 0 : undefined,
            }}
        >
            <WarehouseColumn
                warehouse={warehouse}
                warehouses={warehouses}
                inventoryItems={inventoryItems}
                hasFullAccess={hasFullAccess}
                currencySign={currencySign}
                isFiltering={isFiltering}
                activeInventoryGuid={activeInventoryGuid}
                inventoryDropPreviewIndex={inventoryDropPreviewIndex}
                isInventoryDragDisabled={isInventoryDragDisabled}
                columnDragHandleProps={{
                    ...attributes,
                    ...listeners,
                }}
            />
        </div>
    );
};
